"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.AuthGroups = void 0;
var utils_1 = require("../utils");
var authGroup_1 = require("./authGroup");
var isSystemAdmin = function (authGroup) { return (authGroup === null || authGroup === void 0 ? void 0 : authGroup.name) === authGroup_1.AuthGroupName.systemAdmin; };
var getRecordSteps = function (authGroup) {
    return authGroup === null || authGroup === void 0 ? void 0 : authGroup.recordSteps;
};
var getRecordEditLevel = function (step) { return function (authGroup) {
    var steps = getRecordSteps(authGroup);
    if (!steps)
        throw new Error('No steps');
    return steps[step];
}; };
var getDefaultAuthGroups = function (surveyUuid) {
    return authGroup_1.DEFAULT_AUTH_GROUPS.map(function (group) { return (__assign(__assign({}, group), { uuid: utils_1.UUIDs.v4(), surveyUuid: surveyUuid })); });
};
exports.AuthGroups = {
    isSystemAdmin: isSystemAdmin,
    getRecordEditLevel: getRecordEditLevel,
    getDefaultAuthGroups: getDefaultAuthGroups
};
//# sourceMappingURL=authGroups.js.map